// extracted by mini-css-extract-plugin
export default {"crashSightSubheader":"CrashSightSubheader__crashSightSubheader__mElCu","title":"CrashSightSubheader__title__DJ3dY"};